module.exports = __webpack_public_path__ + "img/episode6.969c0951.png";